import { get } from 'lodash';

export const getLoadingFromStore = state =>
  get(state, 'GenericExportState.MonthlyExport.loading');

export const getExportFileTypeFromStore = state =>
  get(state, 'GenericExportState.MonthlyExport.exportFileTypes');

export const getSubmittingFromStore = state =>
  get(state, 'GenericExportState.MonthlyExport.submitting');

export const getErrorFromStore = state =>
  get(state, 'GenericExportState.MonthlyExport.error');



// WEBPACK FOOTER //
// ./src/pages/genericexport/state/selectors.js